"use client";
import { Pagination } from "antd";
import Link from "next/link";
import { useRouter } from "next/navigation";
import "./style/CustomPagination.css";
import Global from "@/utils/global";

type CustomPaginationProps = {
  total?: number;
  current?: number;
  pageSize?: number;
  container?: string;
  path?: string;
  renderUrl?: boolean;
  onChange?: (page: number, pageSize: number) => void;
};
export const CustomPagination: React.FC<CustomPaginationProps> = ({
  total = 0,
  pageSize = 10,
  current,
  onChange,
  renderUrl,
  path,
  ...props
}) => {
  const router = useRouter();

  if (!total) {
    return null;
  }

  const getUrl = (page: number) => {
    // 获取当前 URL
    const currentUrl =
      (process.env.NEXT_PUBLIC_ISDev === "true"
        ? "http://localhost:3000/"
        : process.env.NEXT_PUBLIC_ISTest === "true"
          ? "https://www.bravve.cn/"
          : (Global.domainUrl as string)) + path;

    // 解析查询参数
    const url = new URL(currentUrl);
    const searchParams = new URLSearchParams(url.search);

    // 设置或更新 `page` 参数
    // const page = 2; // 你想要添加的 `page` 参数值
    searchParams.set("page", page.toString());

    // 构建新的 URL
    return `${url.origin}${url.pathname}?${searchParams.toString()}`;
  };

  return (
    <div className={props?.container ?? "m-auto my-32 lg:mb-32 lg:mt-60"}>
      <Pagination
        className="customPagination flex justify-center lg:w-334"
        style={{ margin: "0 auto" }}
        current={current}
        defaultPageSize={pageSize}
        showSizeChanger={false}
        total={total}
        prevIcon={
          <div
            className={`flex h-32 w-32 justify-center rounded-xs border border-bravve-line-200 p-7 text-bravve-bg-100`}
          >
            <iconpark-icon
              icon-id="page-left"
              size="1.6rem"
              name="left"
              color={current === 1 ? "#B8B8B8" : "#402C22"}
            />
          </div>
        }
        nextIcon={
          <div
            className={`flex h-32 w-32 justify-center rounded-xs border border-bravve-line-200 p-7 text-bravve-bg-100`}
          >
            <iconpark-icon
              icon-id="page-right"
              size="1.6rem"
              name="right"
              color={
                current === Math.ceil(total / pageSize) ? "#B8B8B8" : "#402C22"
              }
            />
          </div>
        }
        itemRender={(page, type, originalElement) => {
          if (renderUrl) {
            if (type === "page") {
              return <Link href={getUrl(page)}>{page}</Link>;
            } else {
              if (page) {
                // @ts-ignore
                if (originalElement?.type === "a") {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        router.push(getUrl(page));
                      }}
                    >
                      {originalElement}
                    </div>
                  );
                }
                
                return (
                  <Link href={getUrl(page)}>
                    <>{originalElement}</>
                  </Link>
                );
              }

              return originalElement;
            }
          } else {
            return originalElement;
          }
        }}
        onChange={(page, pageSize) => {
          onChange?.(page, pageSize);
        }}
      />
    </div>
  );
};
